import { render } from "./EditGroupMemberModal.vue?vue&type=template&id=07594401&scoped=true"
import script from "./EditGroupMemberModal.vue?vue&type=script&lang=js"
export * from "./EditGroupMemberModal.vue?vue&type=script&lang=js"

import "./EditGroupMemberModal.vue?vue&type=style&index=0&id=07594401&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07594401"]])

export default __exports__